<template>
  <div id="welcome">
    <the-top-bar :title="sectionTitle" />
    <div style="position:relative; max-width: 500px; margin: auto;">
      <loading-progress :viewOverlay="false" data-message=" " v-if="!ready" />
    </div>
    <transition name="fade">
      <welcome-modal v-show="ready" :data-slides="slides" @setState="$_guideEvent($event)"></welcome-modal>
    </transition>
  </div>
</template>
<script>
import loadingProgress from "@/components/loadingProgress";
import { payload } from "@/schemas/welcome";
import TheTopBar from "@/components/TheTopBar.vue";
import welcomeModal from "@/components/welcomeModal.vue";
import { mapActions } from "vuex";
export default {
  name: "Welcome",
  components: {
    loadingProgress,
    TheTopBar,
    welcomeModal,
  },
  data() {
    return {
      ...payload,
      showRegisterLogin: false,
      title: false,
      ready: false,
      modalState: "open",
    };
  },
  mounted() {
    //this.setFirstLoad(false);

    setTimeout(() => {
      this.ready = true;
    }, 1500);
  },
  computed: {
    sectionTitle: {
      get() {
        return this.title ? this.title : "Welcome";
      },
    },
  },
  methods: {
    ...mapActions("Main", { setFirstLoad: "setFirstLoad" }),

    $_slideTitle($event) {
      this.title = $event;
    },
    $_guideEvent(e) {
      this.modalState = e;
    },
    $_goTo() {
      this.setFirstLoad(false);
      this.$router.push({ name: "Register" });
    },
  },
};
</script>
<style lang="scss" scoped>
#welcome {
  /* background: #fff; */
  height: 100vh;

  @media screen and (min-width: 1024px) {
    height: calc(100vh - 64px);
  }

  .inner-content {
    position: relative;
    padding: 1rem;

    .clouds-sun-wrapper {
      position: absolute;
      top: 2rem;
      right: 1rem;
      // margin: 0 auto;
      height: 100px;
      width: 180px;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .welcome-wrapper {
      margin: 110px auto 0 auto;
      // height: 210px;
      width: 90%;

      img {
        height: 100%;
        width: 100%;
      }
    }

    .info-container {
      .title {
        font-size: 30px;
        text-align: center;
      }

      .text {
        color: #8b8b8b;
        text-align: center;
      }
    }

    .btn-container {
      margin-top: 3rem;
      margin-bottom: 1rem;
      display: flex;
      justify-content: center;

      .btn-start {
        // padding: 0 3rem;
        // background: #fccc46;
        // color: #000;
        // border-radius: 25px;
        // box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
        // box-shadow: none;
      }
    }
  }
}

.fade-enter-active {
  transition: all 0.2s linear;
}

.fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}</style>
